export const API_ENDPOINTS = {
  TIW_API: process.env.VUE_APP_TIW_API || '/api',
  PORTAL_API: process.env.VUE_APP_PORTAL_API || ''
};

export default API_ENDPOINTS;
